import $ from 'jquery'

if ($('.price-info').length) {
    // Make AJAX request to the API
    $.ajax({
        url: '/wp-json/vp-stock-price/v1/price',
        type: 'GET',
        dataType: 'json',
        success: function(result) {
            // Remove d-none class from .price-info
            $('.price-info').removeClass('d-none');
            
            // Format and display stock price
            var formattedPrice = parseFloat(result['Price']).toFixed(2) + 'USD';
            $('.price-info .stock-price').text(formattedPrice);
            
            // Format and display change
            var change = parseFloat(result['Change']);
            var changePercent = parseFloat(result['ChangePercent']);
            var formattedChange = change.toFixed(2) + ' (' + changePercent.toFixed(2) + '%)';
            
            // Check if change is negative
            if (change < 0) {
                // Display negative change in .price-down
                $('.price-info .price-down').find('span').text(formattedChange);
                $('.price-info .price-down').removeClass('d-none');
            } else {
                // Display positive change in .price-up
                $('.price-info .price-up').find('span').text(formattedChange);
                $('.price-info .price-up').removeClass('d-none');
            }
        },
        error: function(xhr, status, error) {
            console.error('Error fetching stock price:', error);
        }
    });
}
